export const parseNum = (val) => {
  if (val !== "" && val !== null && val !== undefined) {
    return parseFloat(val) || 0;
  }
  return 0;
};

export const formatCurrency = (val) => {
  if (val !== null && val !== undefined && !isNaN(val)) {
    return Number(val).toLocaleString("en-IN");
  }
  return "0";
};


// Calculate contract fees & totals
export const calculateContractSalary = (inputStates = {}) => {
  const cFeesM = parseNum(inputStates.contractFees);
  const cFeesY = cFeesM * 12;

  const cOtherM = parseNum(inputStates.contractOtherAllow);
  const cOtherY = cOtherM * 12;

  const cMobileM = parseNum(inputStates.mobileConnect);
  const cMobileY = cMobileM * 12;

  const cMedM = parseNum(inputStates.medical);
  const cMedY = cMedM * 12;

  const cTotalM = cFeesM + cOtherM + cMobileM + cMedM;
  const cTotalY = cTotalM * 12;

  return {
    cFeesM, cFeesY,
    cOtherM, cOtherY,
    cMobileM, cMobileY,
    cMedM, cMedY,
    cTotalM, cTotalY,
  };
};

// Calculate Payrole CTC breakdown & totals
export const convertNumberToWords = (amount) => {
  const num = Math.round(parseNum(amount));
  if (num === 0) return "Zero Rupees Only";

  const single = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

  const numToWords = (n) => {
    if (n < 20) return single[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + single[n % 10] : "");
    if (n < 1000) return single[Math.floor(n / 100)] + " Hundred" + (n % 100 !== 0 ? " " + numToWords(n % 100) : "");
    if (n < 100000) return numToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 !== 0 ? " " + numToWords(n % 1000) : "");
    if (n < 10000000) return numToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 !== 0 ? " " + numToWords(n % 100000) : "");
    return numToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 !== 0 ? " " + numToWords(n % 10000000) : "");
  };

  return `${numToWords(num)} Only`;
};

// Calculate Payrole CTC breakdown & totals
export const calculateFulltimeSalary = (inputStates = {}) => {
  const basicM = parseNum(inputStates.basicSalary || inputStates.basicM);
  const basicY = basicM * 12 || parseNum(inputStates.basicY);

  const houseM = parseNum(inputStates.houseAllow || inputStates.houseM);
  const houseY = houseM * 12 || parseNum(inputStates.houseY);

  const eduM = parseNum(inputStates.educationAllow || inputStates.eduM);
  const eduY = eduM * 12 || parseNum(inputStates.eduY);

  const medM = parseNum(inputStates.medicalReimb || inputStates.medM);
  const medY = medM * 12 || parseNum(inputStates.medY);

  const convM = parseNum(inputStates.conveyance || inputStates.convM);
  const convY = convM * 12 || parseNum(inputStates.convY);

  const personalM = parseNum(inputStates.personalAllow || inputStates.personalM);
  const personalY = personalM * 12 || parseNum(inputStates.personalY);

  const cityM = parseNum(inputStates.cityCompAllow || inputStates.cityM);
  const cityY = cityM * 12 || parseNum(inputStates.cityY);

  const otherM = parseNum(inputStates.otherAllow || inputStates.otherM);
  const otherY = otherM * 12 || parseNum(inputStates.otherY);

  let subAM = basicM + houseM + eduM + medM + convM + personalM + cityM + otherM;
  let subAY = subAM * 12;

  const pfM = parseNum(inputStates.companyPF || inputStates.pfM);
  const pfY = pfM * 12 || parseNum(inputStates.pfY);

  const gratuityY = Math.round(basicY * 0.0481);

  const healthY = parseNum(inputStates.annualHealthCheck || inputStates.healthY);
  const perfoY = parseNum(inputStates.perfoIncentive || inputStates.perfoY);

  let subBY = pfY + gratuityY + healthY + perfoY;
  let totalY = subAY + subBY;

  if (totalY > 0 && subAY === 0) {
    subAY = Math.round(totalY * 0.85);
    subAM = Math.round(subAY / 12);
    subBY = totalY - subAY;
  }

  return {
    basicM, basicY,
    houseM, houseY,
    eduM, eduY,
    medM, medY,
    convM, convY,
    personalM, personalY,
    cityM, cityY,
    otherM, otherY,
    subAM, subAY,
    pfM, pfY,
    gratuityY,
    healthY,
    perfoY,
    subBY,
    totalY,
  };
};

// Dynamic rows for Contract Fees Annexure Table
export const getContractTableRows = (inputStates = {}) => {
  const c = calculateContractSalary(inputStates);
  return [
    { label: "Contract Fees / Professional Fees", monthly: c.cFeesM, yearly: c.cFeesY },
    { label: "Other Allowances", monthly: c.cOtherM, yearly: c.cOtherY },
    { label: "Mobile Connectivity Allowance", monthly: c.cMobileM, yearly: c.cMobileY },
    { label: "Medical Allowance", monthly: c.cMedM, yearly: c.cMedY },
  ].filter((r) => r.monthly > 0);
};

// Dynamic rows for Payrole CTC Annexure Table
export const getFulltimeTableRows = (inputStates = {}) => {
  const f = calculateFulltimeSalary(inputStates);

  const subA = [
    { label: "Basic Salary", monthly: f.basicM, yearly: f.basicY },
    { label: "House Rent Allowance", monthly: f.houseM, yearly: f.houseY },
    { label: "Education Allowance", monthly: f.eduM, yearly: f.eduY },
    { label: "Medical", monthly: f.medM, yearly: f.medY },
    { label: "Conveyance", monthly: f.convM, yearly: f.convY },
    { label: "Personal Allowance", monthly: f.personalM, yearly: f.personalY },
    { label: "City Compensatory Allowance", monthly: f.cityM, yearly: f.cityY },
    { label: "Other Allowance", monthly: f.otherM, yearly: f.otherY },
  ].filter((r) => r.monthly > 0 || r.yearly > 0);

  const subB = [
    { label: "Company's Contribution to P.F.", monthly: f.pfM, yearly: f.pfY },
    { label: "Company's Contribution to Gratuity (4.81%)", monthlyLabel: "-", yearly: f.gratuityY },
    { label: "Annual Health checkup", monthlyLabel: "-", yearly: f.healthY },
    { label: "Performance Incentive", monthlyLabel: "-", yearly: f.perfoY },
  ].filter((r) => r.yearly > 0 || (r.monthly && r.monthly > 0));

  return {
    subA,
    subB,
    totals: f,
  };
};
